var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"text"},[_vm._v("このURLは、移動または削除されたため、現在表示することができません。")]),_c('border-button',{staticClass:"button",attrs:{"to":"/"}},[_vm._v("ホームに戻る")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }